import { FC } from 'react';
import classNames from 'classnames';
import homeBackgroundCss from '#home/components/background/assets/home-background.module.scss';

type PropsType = {
  src: string;
  additionalClassName?: string;
};

const BackgroundImage: FC<PropsType> = ({
  src,
  additionalClassName = null,
}) => (
  <img
    src={src}
    className={classNames(
      homeBackgroundCss.homeBackground__image,
      additionalClassName,
    )}
    alt="Main"
    fetchPriority="high"
  />
);

export { BackgroundImage };
